import { render } from "./Qualidade.vue?vue&type=template&id=1ef19026&scoped=true"
import script from "./Qualidade.vue?vue&type=script&lang=js"
export * from "./Qualidade.vue?vue&type=script&lang=js"

import "./Qualidade.vue?vue&type=style&index=0&id=1ef19026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef19026"]])

export default __exports__